var moduleMap = {
	"./Router": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_extends_js-node_modules_prop-types_index_js"), __webpack_require__.e("vendors-node_modules_material-ui_core_esm_styles_withStyles_js"), __webpack_require__.e("vendors-node_modules_material-ui_core_esm_IconButton_IconButton_js-node_modules_material-ui_c-60667e"), __webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_defineProperty_js-node_modules_babel_runtime_h-50a7af"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_material-ui_styles_material-ui_styles"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("src_bootstrap_ConfigWrapper_tsx"), __webpack_require__.e("webpack_sharing_consume_default_material-ui_core_styles_material-ui_core_styles-webpack_shari-c8ee6c"), __webpack_require__.e("src_Router_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/Router.tsx */ "./src/Router.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var oldScope = __webpack_require__.S["default"];
	var name = "default"
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});